import { Button as MuiButton } from '@mui/material';
import { forwardRef } from 'react';

const Button = forwardRef((props, ref) => {
  return(
    <MuiButton ref={ref} disableElevation {...props}/>
  );
});
export default Button;